import {Button, Form, Input, Select, Spin} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {PropTypes} from 'prop-types';
import {useEffect, useState} from 'react';
import {toast} from'react-hot-toast';
import 'react-country-state-city/dist/react-country-state-city.css';
import {useSelector} from'react-redux';

import {RQGetUserDetails, RQUpdateUserProfileAPI, RqGetDeliveryCharges} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';
const AddressSection = ({
  setAddressComplete,
  setdeliveryCharges,
  setDeliveryDays,
  setHasUnsavedAddress,
}) => {
  const [form] = Form.useForm();

  const [setIsSubmitted] = useState(false);

  const [isFormOpen, setIsFormOpen] = useState(false);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const decodedToken = token ? jwtDecode(token) : null;

  const id = decodedToken?.userId;

  const {data: userData, isLoading, refetch} = RQGetUserDetails(id, token);

  const {data: stateData} = RqGetDeliveryCharges(token);

  const {mutate: updateUserProfile} = RQUpdateUserProfileAPI();

  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (userData && stateData) {
      const values = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        mobile: userData.mobile,
        address: userData.address,
        street: userData.street,
        apartment: userData.apartment,
        pinCode: userData.pinCode,
        city: userData.city,
        district: userData.district,
        state: userData.state,
      };

      form.setFieldsValue(values);

      const allFilled = Object.values(values).every(
        v => v && v.toString().trim() !== '',
      );

      setIsComplete(allFilled);
      setAddressComplete(allFilled);
      setHasUnsavedAddress(false);
     
      if (userData.state) {
        handleStateChange(userData.state);
      }
    }
  }, [userData, stateData]);  

  const onFinish = values => {
    const formData = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: userData?.email || '',
      mobile: values.mobile,
      address: values.address,
      street: values.street,
      apartment: values.apartment,
      pinCode: values.pinCode,
      city: values.city,
      district: values.district,
      state:values.state,
    };
    updateUserProfile(
      {token, formData, id},
      {
        onSuccess: () => {
          toast.success('Profile updated successfully!');
          refetch();
          setIsFormOpen(false);
          setHasUnsavedAddress(false);
        },
        onError: error => {
          toast.error('Failed to update profile');
        },
      },
    );
    setIsSubmitted(true);
    setIsFormOpen(false);
  };
  useEffect(() => {
    setAddressComplete?.(isComplete);
  }, [isComplete, setAddressComplete]);

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleStateChange = selectedState => {

    if (!stateData || !selectedState) {return;}

    const cleanState = selectedState.trim().toLowerCase();

    const match = stateData.find(item =>
      item.state?.some(
        s => s.trim().toLowerCase() === cleanState,
      ),
    );

    console.log('Selected:', selectedState);
    console.log('Matched:', match);

    if (match) {

      setdeliveryCharges(Number(match.charges) || 0);

      setDeliveryDays(Number(match.deliveryDays) || null);

    } else {

      setdeliveryCharges(0);

      setDeliveryDays(null);

    }

  };
  
  if (isLoading) {
    return <div className={'flex justify-center items-center'}><Spin /></div>;
  }

  return (
    <div className={'w-full'}>
      <div className={'flex flex-col gap-1 p-2 border-primary-200 rounded-lg items-start'}>
        <h1 className={'text-base font-semibold'}>Deliver To:</h1>
        <div className={'lg:text-base'}>
          {userData ? 
            (  
              <div>
                <div>{userData?.firstName} {userData?.lastName}</div>
                <div>{userData?.street} ,{userData?.apartment} ,{userData?.city}, {userData?.district}, {userData?.state} {userData?.pinCode}</div>
                <div>{userData?.mobile}</div>
              </div>
            )
            :
            ( '-')
          }
        </div>
      </div>
      <div>
        <div className={'flex items-start flex-col gap-2'}>
          <Button
            color={'default'}
            type={'primary'}
            className={'p-1 !text-white  my-3 text-md w-28'}
            onClick={handleFormToggle}
          >
            {isFormOpen ? 'Cancel' : 'Edit Address'}
          </Button>
        </div>

        {isFormOpen && (
          <Form
            layout={'vertical'}
            form={form}
            name={'address'}
            initialValues={{remember: true}}
            onFinish={onFinish}
            className={'lg:w-full'}
            onValuesChange={(changedValues, allValues) => {

              setHasUnsavedAddress(true);

              if (changedValues.state) {
                handleStateChange(changedValues.state);
              }

              const allFilled = Object.values(allValues).every(
                v => v && v.toString().trim() !== '',
              );

              setIsComplete(allFilled);
              setAddressComplete(allFilled);

            }}
          >
            <div className={'grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4'}>
              <Form.Item label={'First Name'}
                name={'firstName'}
                rules={[
                  {required: true},
                  {whitespace: true, message: ''},
                  {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
                ]}>
                <Input   placeholder={'Name'} />
              </Form.Item>

              <Form.Item label={'Last Name'}
                name={'lastName'}
                rules={[
                  {required: true},
                  {whitespace: true, message: ''},
                  {pattern: /^[A-Za-z]+$/, message: 'Only letters are allowed'},
                ]}>
                <Input   placeholder={'Name'} />
              </Form.Item>

              <Form.Item label={'Contact No'}
                name={'mobile'}
                rules={[
                  {required: true, message: 'Please enter your contact number'},
                  {pattern: /^[0-9]{10}$/, message: 'Enter exactly 10 digits'},
                ]}
                normalize={value => value.replace(/\D/g, '').slice(0, 10)}
                className={'w-full'}
              >
                <Input
                  type={'number'}
                  placeholder={'Contact No'}
                />
              </Form.Item>

              <Form.Item
                label={'Pincode'}
                name={'pinCode'}
                rules={[
                  {required: true, message: 'Pincode is required'},
                  {len: 6, message: 'Pincode must be 6 digits'},
                ]}
                normalize={value => value.replace(/\D/g, '').slice(0, 6)}
                className={'w-full'}
              >
                <Input type={'number'}  placeholder={'Pincode'} />
              </Form.Item>
    
              <Form.Item
                label={'State'}
                name={'state'}
                rules={[
                  {required: true, message: 'State is required'},
                  {whitespace: true, message: 'State is required'},
                ]}>
                <Select
                  placeholder={'Select state'}
                  allowClear
                  onChange={value => handleStateChange(value)}
                >
                  {Array.isArray(stateData) &&
                  stateData.flatMap(item => item.state).map((state, index) => (
                    <Select.Option key={index} value={state}>
                      {state}
                    </Select.Option>
                  ))
                  }
                </Select>
              </Form.Item>

              <Form.Item
                label={'District'}
                name={'district'}
                rules={[
                  {required: true, message: 'District is required'},
                  {whitespace: true, message: 'District is required'},
                ]}>
                <Input placeholder={'District'} />
              </Form.Item>
            
              <Form.Item
                label={'City'}
                name={'city'}
                rules={[
                  {required: true, message: 'City is required'},
                  {whitespace: true, message: 'City is required'},
                ]}>
                <Input placeholder={'City'} />
              </Form.Item>

              <Form.Item
                label={'Street'}
                name={'street'}
                rules={[
                  {required: true, message: 'Street is required'},
                  {whitespace: true, message: 'Street is required'},
                ]}>
                <Input placeholder={'Road name/area/colony'} />
              </Form.Item>

              <Form.Item
                label={'Apartment'}
                name={'apartment'}
                rules={[
                  {required: true, message: 'Apartment is required'},
                  {whitespace: true, message: 'Apartment is required'},
                ]}>
                <Input placeholder={'Apartment'} />
              </Form.Item>

              <Form.Item label={'Address'} name={'address'}
                rules={[
                  {required: true, message: 'Address is required'},
                  {whitespace: true, message: 'Address is required'},
                ]}>
                <Input.TextArea  placeholder={'address'} />
              </Form.Item>
            </div>

            <Form.Item>
              <Button type={'primary'} htmlType={'submit'} className={'!bg-primary-900 text-sm text-white w-48'}>
                    Save
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </div>
  );
};

AddressSection.propTypes = {
  setAddressComplete: PropTypes.func,
  setdeliveryCharges: PropTypes.func,
  setDeliveryDays: PropTypes.func,
  setHasUnsavedAddress: PropTypes.func,
};

export default AddressSection;
